import React from "react"
import { graphql } from "gatsby"
import styled from "styled-components"
import { Breakpoints } from "../utils/variables"

import { ParallaxBanner } from "react-scroll-parallax"

import Layout from "../components/Layout"
import SEO from "../components/Seo"
import HeaderTitle from "../components/HeaderTitle"
import AccordionItem from "../components/AccordionItem"
import ContentBlock from "../components/ContentBlock"

export const HeaderImage = styled.div`
  width: 100%;
  margin: 0 auto 30px auto;

  @media screen and (min-width: ${Breakpoints.wide}) {
    margin: 0 auto 100px auto;
  }
`

export const Accordion = styled.ul`
  width: 100%;
`

class TherapeuticApplications extends React.Component {
  render() {
    const page = this.props.data.page.data
    const posts = this.props.data.posts.nodes

    return (
      <Layout theme="dark">
        <SEO title={page.header_title.text} />

        <HeaderTitle label={page.header_title.text} />

        <HeaderImage>
          <ParallaxBanner
            layers={[
              {
                image: page.header_image.url,
                amount: 0.4,
              },
            ]}
            style={{
              width: "100%",
              height: "62vh",
            }}
          />
        </HeaderImage>

        <ContentBlock data={page.content.html} />

        <Accordion>
          {posts.map((item, index) => {
            return <AccordionItem key={index} data={item} index={index} />
          })}
        </Accordion>
      </Layout>
    )
  }
}

export default TherapeuticApplications

export const pageQuery = graphql`
  query {
    page: prismicTherapeuticApplications {
      data {
        header_title {
          text
        }
        header_image {
          url
          alt
        }
        content {
          html
        }
      }
    }
    posts: allPrismicApplicationsItem {
      nodes {
        data {
          title {
            text
          }
          icon {
            text
          }
          content {
            html
          }
        }
      }
    }
  }
`
